<template>
  <div>
    <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px">
      <el-row>
        <el-col :span="11">
          <el-form-item label="订单编号" prop="order_no">
            <el-input
              v-model="formData.order_no"
              placeholder="请输入订单编号"
              clearable
              :style="{width: '100%'}"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item size="large">
        <el-button type="primary" @click="submitForm">查询</el-button>
        <el-button type="warning" @click="resetForm" v-show="buttonshow">退货</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import util from "../../../util/date";
import { GetOrderReturn, GetOrderReturnPut } from "../../api/api";

export default {
  components: {},
  props: [],
  data() {
    return {
      buttonshow: false,
      formData: {
        order_no: undefined,
      },
      rules: {
        order_no: [
          {
            required: true,
            message: "请输入订单编号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {
    formData: {
      handler: function () {
        this.buttonshow = false;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    let order_no = this.$route.query.order_no;
   
    if(order_no!=null){
       console.log(order_no);
      this.formData.order_no=order_no;
    }
  },
  methods: {
    GetOrderReturn1() {
      let order_no = this.formData.order_no;
      let para = {
        order_no: order_no,
      };
      GetOrderReturn(para).then((res) => {
        console.log(res);
        if (res.data.success) {
          if (res.data.response.StatusCode == 0) {
            this.$message({
              message: "该笔订单已退货，不能重复退货",
              type: "error",
            });
          } else {
            this.buttonshow = true;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        // TODO 提交表单
        console.log(this.formData.order_no);
        this.GetOrderReturn1();
      });
    },
    resetForm() {
      this.$confirm("确认退货该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        let order_no = this.formData.order_no;
        let para = {
          order_no: order_no,
        };
        GetOrderReturnPut(para).then((res) => {
          if (util.isEmt.format(res)) {
            return;
          }
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
             this.buttonshow = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>
<style>
</style>
